import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AeAuthService } from '@extranet/services/auth-service';

@Injectable()
export class IsProspectNotLogged implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly aeAuthService: AeAuthService
  ) {}

  public canActivate(): boolean | UrlTree {
    if (!this.aeAuthService.isLogged) {
      this.aeAuthService.getLoginStorage();
    }
    if (this.aeAuthService.isLogged) {
      return this.router.createUrlTree(['/app']);
    }
    return true;
  }
}
